import styled from "styled-components";

export const PictureNewUserWelfare = styled.div`
  width: 100%;
  max-width: 654px;
  height: 36px;
  line-height: 36px;
  display: flex;
  align-items: center;
  background-size: 100% 100%;
  color: rgba(238, 111, 46, 1);
  font-weight: 600;
  font-size: 14px;
  font-family: "PingFang SC";
  margin-bottom: 16px;
  background: rgba(254, 246, 242, 1);
  border: 1px solid rgba(246, 190, 151, 1);
  border-radius: 8px;
  .title {
    background: linear-gradient(104.14deg, #ee715f 2.8%, #eb4846 92.67%);
    height: 38px;
    line-height: 38px;
    color: white;
    padding: 0 10px;
    border-radius: 8px 0 0 8px;
    margin-left: -1px;
  }
  .welfare-content {
    padding: 0 10px;
  }
  .sub-title {
    color: rgba(100, 48, 14, 1);
    margin-right: 10px;
  }
  .line {
    color: rgba(223, 207, 197, 1);
    margin: 0 8px;
  }
  .count-down {
    display: inline-flex;
    height: 22px;
    line-height: 22px;
    text-align: center;
  }
  .count-down div {
    background: rgba(251, 228, 221, 1);
    border-radius: 4px;
    width: 30px;
    margin: 0 4px;
  }
`;
